<div id="{{mapId}}" class="w-full shadow-lg" [ngClass]="isHeightClass ? mapHeight : ''" [style.height]="isHeightClass ? null : mapHeight"></div>

  